import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NumberingTypes } from 'fakturnia-shared/dist/enums/numbering-types.enum';
import { SettingsService } from 'shared/services/settings.service';
import { Subscription } from 'rxjs';
import { APIResponse, AppData, NotificationData, ObjectUtils, UserSettings } from 'fakturnia-shared';
import { SettingsApiService } from 'shared/services/api/settings.api.service';
import { ToastService } from 'shared/services/toast.service';
import { SnackbarService } from 'shared/services/snackbar.service';

@Component({
  selector: 'app-numbering-type',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule],
  templateUrl: './numbering-type.component.html',
  styleUrl: './numbering-type.component.scss'
})
export class NumberingTypeComponent implements OnInit, OnDestroy {

  private _subscriptions: Subscription[] = []
  numberingTypes = [
    { id: NumberingTypes.MONTH, name: 'Miesięczny' },
    { id: NumberingTypes.YEAR, name: 'Roczny' },
  ]
  public numberingFormat = null
  control = new FormControl(NumberingTypes.MONTH)

  constructor(
    private _settingsService: SettingsService,
    private _settingsApiService: SettingsApiService,
    private _toastService: ToastService,
    private _snackbarService: SnackbarService
  ) { }

  public isDisabled(type) {
    if(this.numberingFormat === null) return true
    const format = AppData.DocumentNumberFormats.find(x=>x.format == this.numberingFormat)
    if(format == null) return true
    if(type == NumberingTypes.MONTH && !format.format.includes('MM')) return true
    return false
  }

  ngOnInit(): void {
    this._subscriptions.push(
      this._settingsService.currentUserSettings.subscribe({
        next: (userSettings: UserSettings) => {
          this.numberingFormat = ObjectUtils.getNestedValue(userSettings, "settings.autocomplete.numberingFormat")
          this.control.setValue(ObjectUtils.getNestedValue(userSettings, "settings.autocomplete.numberingType"), { emitEvent: false })
        }
      }))

    this._subscriptions.push(
      this.control.valueChanges.subscribe((value) => {
        this._settingsApiService.updateNumberingType(value)
          .subscribe({
            next: (response: APIResponse) => {
              if (!response.success) {
                this._settingsService.refreshSettings()
                this._snackbarService.showSnackBar(
                  response.message,
                  "error", 
                  4000
                )
                return
              }

              this._settingsService.refreshSettings()
              
              this._snackbarService.showSnackBar(
                "Zapisano zmiany",
                "success", 
                4000
              )

            }
          })
      })
    )
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(sub => sub.unsubscribe())
  }

}
